import site from '../../site';

const getPageLocaleById = (state, pageId) => {
  const targetPage = site.selectors.getPage(state, pageId);

  if (!targetPage) return null;

  return targetPage.locale;
};

export default getPageLocaleById;
